import React from 'react'

const withLayout = (PageComponent, Layout) => {
  const Wrapped = props => (
    <Layout>
      <PageComponent {...props} />
    </Layout>
  )
  return Wrapped
}

export default withLayout
